var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRtf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.7213 0 20.936 23.9554",
    width: "20.936px",
    height: "23.9554px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-RTF",
    className: "fill-on-hover",
    strokeWidth: 1,
    fill: "#333",
    fillRule: "evenodd",
    style: {},
    transform: "matrix(1, 0, 0, 0.976563036441803, 242.28314208984375, 234.30168151855472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0,
    transform: "matrix(1, 0, 0, 0.976563, -0.000005, 0.000001)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "matrix(1, 0, 0, 0.976563, -0.000005, 0.000001)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier",
    transform: "matrix(0.051443, 0, 0, 0.050238, -243.263245, -251.579102)",
    style: {}
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 342.926 0 L 52.513 0 L 52.513 512 L 459.487 512 L 459.487 116.561 L 342.926 0 Z M 353.651 30.839 L 430.225 107.01 L 354.371 105.73 L 353.651 30.839 Z M 449.857 499.383 L 64.773 498.623 L 63.684 13.417 L 341.368 14.01 L 341.074 118.316 L 450.711 119.688 L 449.857 499.383 Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 282.255 183.795 C 227.965 183.795 183.795 227.965 183.793 282.257 C 183.793 302.296 189.825 320.946 200.148 336.516 L 102.599 433.586 L 131.987 465.858 L 227.997 364.365 C 243.566 374.688 262.217 380.719 282.256 380.719 C 336.548 380.719 380.718 336.549 380.718 282.257 C 380.718 227.965 336.547 183.795 282.255 183.795 Z M 282.255 341.333 C 249.68 341.333 223.178 314.831 223.178 282.257 C 223.179 249.681 249.681 223.179 282.255 223.179 C 314.83 223.179 341.332 249.681 341.332 282.256 C 341.332 314.831 314.83 341.333 282.255 341.333 Z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtf);
export default __webpack_public_path__ + "static/media/rtf.4bfd46f73999d1808cd82f9b6d9daf2a.svg";
export { ForwardRef as ReactComponent };